import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://drafts.csswg.org/css-pseudo-4/#selectordef-target-text}
 */
export class TargetText extends PseudoElementSelector {
    static of() {
        return new TargetText();
    }
    constructor() {
        super("target-text");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (TargetText) {
    TargetText.parse = PseudoElementSelector.parseNonLegacy("target-text", TargetText.of);
})(TargetText || (TargetText = {}));
//# sourceMappingURL=target-text.js.map